var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgError64 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M32 3c-8.378 0-15.17 6.792-15.17 15.17v12.974c0 8.378 6.792 15.17 15.17 15.17s15.17-6.792 15.17-15.17V18.17C47.17 9.792 40.38 3 32 3M19.83 18.17C19.83 11.45 25.28 6 32 6c6.722 0 12.17 5.449 12.17 12.17v12.974c0 6.721-5.448 12.17-12.17 12.17s-12.17-5.449-12.17-12.17zM10.5 29.638a1.5 1.5 0 0 1 1.5 1.5c0 10.864 8.807 19.67 19.67 19.67h.656c10.863 0 19.67-8.806 19.67-19.67a1.5 1.5 0 0 1 3 0c0 12.085-9.455 21.96-21.37 22.634v5.567a1.686 1.686 0 0 1-3.372 0v-5.574C18.394 53.034 9 43.183 9 31.139a1.5 1.5 0 0 1 1.5-1.5M29.996 24a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-9.25-11c0-.69.56-1.25 1.25-1.25h8a1.25 1.25 0 0 1 0 2.5h-8c-.69 0-1.25-.56-1.25-1.25M34.5 33a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2.5 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgError64);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };